import api from './api';

export const login = async (credentials) => {
  try {
    const response = await api.post('/login', new URLSearchParams(credentials).toString());
    // Check if 2FA is required
    if (response.data.requires_2fa) {
      return {
        requires_2fa: true,
        user_id: response.data.user_id,
        email_hint: response.data.email_hint,
        email_sent: response.data.email_sent,
      };
    }
    const token = response.data.JWT;
    const user = response.data.user || null;
    if (token) {
      localStorage.setItem('accessToken', token);
    }
    return { token, user };
  } catch (error) {
    console.error('[authService] Login error:', error.response?.status, error.response?.data);
    throw error.response?.data || error;
  }
};

export const verify2FA = async ({ user_id, code }) => {
  try {
    const response = await api.post('/verify-2fa', { user_id, code });
    const token = response.data.JWT;
    const user = response.data.user || null;
    if (token) {
      localStorage.setItem('accessToken', token);
    }
    return { token, user };
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const resend2FA = async (user_id) => {
  try {
    const response = await api.post('/resend-2fa', { user_id });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const register = async (userData) => {
  try {
    const response = await api.post('/register', userData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getDatos = async () => {
  const response = await api.get('/list/vdatos2025');
  return response.data;
};

export const resetPassword = async (email) => {
  try {
    const response = await api.post('/password/reset', { email });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const logout = () => {
  localStorage.removeItem('accessToken');
};

export const getToken = () => localStorage.getItem('accessToken');

export const isAuthenticated = () => {
  return !!localStorage.getItem('accessToken');
};
